
<div :class="jel_getClassObject(content)">
  <div v-if="isModeInscription" class="ml-n2">
    <ul>
      <li
        v-for="(item, idx) in rules.rules[ruleType]"
        :key="idx"
        :class="{
          texteInit: !validated,
          texteValide: motDePasse && validatePwdCondition(item.regex),
          texteInvalide: validated && !validatePwdCondition(item.regex),
        }"
      >
        {{ item.text }}
      </li>
    </ul>
  </div>
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationProvider
    v-slot="validationContext"
    ref="observer"
    :name="content.libMotDePasse"
    :rules="regleValidation"
    tag="div"
  >
    <!-- On passe par un hidden field pour faire afficher erreurs de valiation -->
    <!-- Ceci est nécessaire car le component Password n'offre par un input field au premier niveau -->
    <b-form-group :label="content.libMotDePasse" label-for="motDePasse" class="mb-1">
      <div class="d-flex">
        <b-form-input
          :id="content.idHTML ? content.idHTML : 'motDePasse'"
          v-model="motDePasse"
          :name="content.nameHTML"
          autocomplete="off"
          :type="passwordInputType"
          :maxlength="rules.maxPwdLength"
          :state="getValidationState(validationContext)"
          @input="afficherMessageForce()"
        ></b-form-input>
        <div
          v-if="isModeInscription"
          class="d-flex justify-content-center flex-column icone-mdp-conteneur"
          @click="toggleHiddenMdp()"
        >
          <span
            v-if="contenuTooltip"
            aria-hidden="true"
            class="password-icon-tooltip text-center"
          >
            {{ contenuTooltip }}
          </span>
          <svg-icon className="icone-mdp" :class="iconeOeil" :icon-name="iconeOeil"></svg-icon>
          <label class="sr-only">{{ $t('compte.mdp.libelleAfficherMdp') }}</label>
        </div>
      </div>
      <password
        :id="content.idHTML ? content.idHTML : 'motDePasse'"
        v-model="motDePasse"
        :name="content.nameHTML"
        defaultClass="form-control"
        :secureLength="rules.minPwdLength"
        :strength-meter-only="true"
        :showStrengthMeter="false"
        :toggle="true"
        :badge="false"
        :maxlength="rules.maxPwdLength"
        @score="updateScore"
        @xblur="$refs.observer.validate()"
        @blur="forceValidate()"
      />
    </b-form-group>
    <div v-if="isModeInscription">
      <ErreurValidation
        v-show="
          validationContext.errors[0] === rules.rules['mdpCaracteresSpeciaux'][0].messageErreur ||
          validationContext.errors[0] === erreurChampObligatoire.message
        "
        :message="validationContext.errors[0]"
        classesCSS="pb-3"
      ></ErreurValidation>
      <div
        v-if="
          validated &&
          validationContext.errors[0] !== rules.rules['mdpCaracteresSpeciaux'][0].messageErreur &&
          validationContext.errors[0] !== erreurChampObligatoire.message
        "
      >
        {{ $t('messageComponent.forceMdp.message') }}
        <span class="font-weight-bold">{{ texteScore }}</span>
      </div>
    </div>
    <div v-else>
      <ErreurValidation
        :message="validationContext.errors[0]"
        classesCSS="pb-3"
      ></ErreurValidation>
      <div v-if="content.lien" class="lienPrimaire">
        <Hyperlien :content="motDePasseOublie" class="petitTexte"></Hyperlien>
      </div>
    </div>
  </ValidationProvider>
</div>
